<template>
  <div class="two-btn-pop pop">
    <div class="pop-box">
      <div class="pop-main">
        <div class="pop-main-top">{{$t('operation.msg')}}</div>
        <div class="pop-main-test">{{popMainText}}</div>
        <div class="pop-main-bottom">
          <button class="btn-black" @click="deleteFn">{{$t('operation.confirm')}}</button>
          <button class="btn-grey" @click="closeTwoBtnPop">{{$t('list.cancel')}}</button>
        </div>
      </div>
      <i class="icon-close" @click="closeTwoBtnPop"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'twoBtnPop',
  props: ['popMainText'],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    closeTwoBtnPop: function () {
      this.$emit('closeTwoBtnPop')
    },
    deleteFn: function () {
      this.$emit('deleteFn')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
</style>



// WEBPACK FOOTER //
// src/components/Et/TwoBtnPop.vue